const hasTP = (vehicle, tpArr) => {
  if (!vehicle || !vehicle.TipoPlaca || !tpArr) return false;
  return tpArr.some(tp => vehicle.TipoPlaca.indexOf(tp) > -1);
};

export const getTags = units => {
  let tags = [];

  tags = units.reduce((acum, unit) => {
    let unitTags = unit.Etiquetas.split(",");
    unitTags.forEach(tag => {
      if (acum) {
        if (acum.filter(t => t === tag).length === 0) {
          acum.push(tag);
        }
      }
    });
    return acum;
  }, []);

  tags = tags.filter(t => t !== "");
  return tags;
};

export default hasTP;



// WEBPACK FOOTER //
// ./src/utilities/unitsFilters.js